import { SendDateAndEventDateList } from "../model/Message";

// 指定日から直近の指定曜日の日付けを算出
export const getDayOfWeek = (sendDate: Date, n: number) => {
  const mon = sendDate.getDate() - sendDate.getDay();
  const x = mon + n;
  return new Date(
    sendDate.getFullYear(),
    sendDate.getMonth(),
    x,
    sendDate.getHours(),
    sendDate.getMinutes());
};
// 指定日または指定回数に達するまで繰り返して日付けを追加
export const setSendDate = (
  firstDay: Date,
  publishEndAt: Date | undefined,
  endDate: Date,
  firstEventAt: Date | undefined,
  firstEventEndAt: Date | undefined,
  offsetDateNum: number | undefined,
  maxCount: number,
  intervalYear = 0,
  intervalMonth = 0,
  intervalDate = 0
): SendDateAndEventDateList[] => {
  let date = firstDay;
  let eventAt = firstEventAt;
  let eventEndAt = firstEventEndAt;
  let count = 0;
  const dateList: SendDateAndEventDateList[] = [];
  while(date <= endDate && count < maxCount) {
    dateList.push({sendDate: date, eventAt: eventAt, eventEndAt: eventEndAt, publishEndAt: publishEndAt});
    date = new Date(
      date.getFullYear() + intervalYear,
      date.getMonth() + intervalMonth,
      date.getDate() + intervalDate,
      date.getHours(),
      date.getMinutes());
    if(eventAt !== undefined && eventEndAt !== undefined) {
      date = new Date(
        eventAt.getFullYear() + intervalYear,
        eventAt.getMonth() + intervalMonth,
        eventAt.getDate() - (offsetDateNum ?? 0) + intervalDate,
        eventAt.getHours(),
        eventAt.getMinutes());
      eventAt = new Date(
        eventAt.getFullYear() + intervalYear,
        eventAt.getMonth() + intervalMonth,
        eventAt.getDate() + intervalDate,
        eventAt.getHours(),
        eventAt.getMinutes());
      eventEndAt = new Date(
        eventEndAt.getFullYear() + intervalYear,
        eventEndAt.getMonth() + intervalMonth,
        eventEndAt.getDate() + intervalDate,
        eventEndAt.getHours(),
        eventEndAt.getMinutes());
    };
    if(publishEndAt !== undefined){
      publishEndAt = new Date(
        publishEndAt.getFullYear() + intervalYear,
        publishEndAt.getMonth() + intervalMonth,
        publishEndAt.getDate() + intervalDate,
        publishEndAt.getHours(),
        publishEndAt.getMinutes());
    };
    count++;
  };
  return dateList;
};
// 第n w曜日の算出
export const getDayAndCount = (date: Date) => {
  return {day: date.getDay(), count: Math.floor((date.getDate() - 1) / 7) + 1};
};
// 指定の第n週、w曜日の日付けを指定日または指定回数に達するまで繰り返して取得
export const setSendDateAndNumberOfWeek = (
  firstDay: Date,
  firstPublishEndAt: Date | undefined,
  endDate: Date,
  firstEventAt: Date | undefined,
  firstEventEndAt: Date | undefined,
  offsetDateNum: number | undefined,
  maxCount: number,
  intervalYear = 0,
  intervalMonth = 0,
  intervalDate = 0,
  day: number,
  count: number,
  eventDay: number | undefined,
  eventCount: number | undefined,
  eventEndDay: number | undefined,
  eventEndCount: number | undefined,
  publishEndDay: number | undefined,
  publishEndCount: number | undefined
): SendDateAndEventDateList[] => {
  let date = firstDay;
  let eventAt = firstEventAt;
  let eventEndAt = firstEventEndAt;
  let publishEndAt = firstPublishEndAt;
  let loop = 0;
  const dateList: SendDateAndEventDateList[] = [];
  while(date <= endDate && loop < maxCount) {
    const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, -1).getDate();
    const days = [];
    for (let j = 1; j <= lastDate; j++){
      const tmpDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        j,
        date.getHours(),
        date.getMinutes());
      if (tmpDate.getDay() !== day) continue; //引数に指定した曜日以外の時は何もしない
      days.push(tmpDate);
    };
    const eventDays = [];
    const eventEndDays = [];
    const publishEndDays = [];
    if(eventAt !== undefined && eventEndAt !== undefined ){
      for (let j = 1; j <= lastDate; j++){
        const tmpEventDate = new Date(
          eventAt.getFullYear(),
          eventAt.getMonth(),
          j,
          eventAt.getHours(),
          eventAt.getMinutes());
        const tmpEventEndDate = new Date(
          eventEndAt.getFullYear(),
          eventEndAt.getMonth(),
          j,
          eventEndAt.getHours(),
          eventEndAt.getMinutes());
        if (tmpEventDate.getDay() !== eventDay
          && tmpEventEndDate.getDay() !== eventEndDay){
          continue; //引数に指定した曜日以外の時は何もしない
        }
        eventDays.push(tmpEventDate);
        eventEndDays.push(tmpEventEndDate);
      }
    }
    if(publishEndAt !== undefined ){
      for (let j = 1; j <= lastDate; j++){
        const tmpPublishEndDate = new Date(
          publishEndAt.getFullYear(),
          publishEndAt.getMonth(),
          j,
          publishEndAt.getHours(),
          publishEndAt.getMinutes());
        if (tmpPublishEndDate.getDay() !== publishEndDay) continue; //引数に指定した曜日以外の時は何もしない
        publishEndDays.push(tmpPublishEndDate);
      }
    }
    const eventDate = eventCount !== undefined ? eventDays[eventCount - 1] : undefined;
    const eventEndDate = eventEndCount !== undefined ? eventEndDays[eventEndCount - 1] : undefined;
    const sendDate = offsetDateNum !== undefined && eventDate !== undefined
      ? new Date(
        eventDate?.getFullYear(),
        eventDate?.getMonth(),
        eventDate?.getDate() - (offsetDateNum ?? 0),
        eventDate?.getHours(),
        eventDate?.getMinutes())
      : days[count - 1];
    const publishEndDate = publishEndCount !== undefined ? publishEndDays[publishEndCount - 1] : undefined;
    dateList.push({sendDate: sendDate, eventAt: eventDate, eventEndAt: eventEndDate, publishEndAt: publishEndDate});
    date = new Date(
      date.getFullYear() + intervalYear,
      date.getMonth() + intervalMonth,
      date.getDate() + intervalDate,
      date.getHours(),
      date.getMinutes());
    if(eventAt !== undefined && eventEndAt !== undefined) {
      eventAt = new Date(
        eventAt.getFullYear() + intervalYear,
        eventAt.getMonth() + intervalMonth,
        eventAt.getDate() + intervalDate,
        eventAt.getHours(),
        eventAt.getMinutes());
      eventEndAt = new Date(
        eventEndAt.getFullYear() + intervalYear,
        eventEndAt.getMonth() + intervalMonth,
        eventEndAt.getDate() + intervalDate,
        eventEndAt.getHours(),
        eventEndAt.getMinutes());
    };
    if(publishEndAt !== undefined){
      publishEndAt = new Date(
        publishEndAt.getFullYear() + intervalYear,
        publishEndAt.getMonth() + intervalMonth,
        publishEndAt.getDate() + intervalDate,
        publishEndAt.getHours(),
        publishEndAt.getMinutes());
    };
    loop++;
  };
  return dateList;
};
